import { lazyClosePreviewPane } from 'mini-preview-pane-view-actions';
import { mailConversationReadingPaneRouteEntryHandler } from './mailConversationReadingPaneRouteHandler';

export interface MailConversationReadingPaneAttachmentPreviewRouteParameters {
    folderId: string;
    conversationId: string;
    attachmentId: string;
}

/**
 * owa-router entry handler for conversation reading pane attachment preview pane
 */
export async function mailConversationReadingPaneAttachmentPreviewRouteEntryHandler(
    params: MailConversationReadingPaneAttachmentPreviewRouteParameters
): Promise<void> {
    const { folderId, conversationId } = params;
    mailConversationReadingPaneRouteEntryHandler({ folderId, conversationId });
}

/**
 * owa-router exit handler for conversation reading pane attachment preview pane
 */
export async function mailConversationReadingPaneAttachmentPreviewRouteExitHandler(
    oldRoute: string[],
    oldParams: any,
    newRoute: string[],
    newParams: any
): Promise<boolean> {
    (await lazyClosePreviewPane.import())();
    return false;
}
